import axios from '../utils/axios';

export default function fetchShowcaseCompanies(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/showcase-companies', { params })
    )
}
